module.exports = __webpack_public_path__ + "static/media/edit-icon.be8a4cc9.svg";